
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class FormatLocalKeyService {
  private primaryKey = 'DATE.FORMAT_ANGULAR';
  private fallbackKey = 'DATE.FORMAT_JAVA';

  constructor(private translate: TranslateService) {}

  getDateFormat(): string {
    const primary = this.translate.instant(this.primaryKey);
    const fallback = this.translate.instant(this.fallbackKey);
    return (primary && primary !== this.primaryKey) ? primary : fallback;
  }
}
